import React from 'react';
import { Lock, ShieldCheck, BadgeCheck } from 'lucide-react';
const badges = [{
  icon: Lock,
  label: 'Secure Payment'
}, {
  icon: ShieldCheck,
  label: '7-Day Guarantee'
}, {
  icon: BadgeCheck,
  label: 'Verified Purchase'
}];
export function TrustBadges({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`grid grid-cols-3 gap-2 md:gap-3 ${className}`} data-id="element-210">
      {badges.map(({
      icon: Icon,
      label
    }) => <div key={label} className="flex flex-col items-center justify-center text-center gap-1.5 md:gap-2 rounded-xl border border-zinc-700/60 bg-black/30 px-2 py-3 md:px-3 md:py-4" data-id="element-211">
          <Icon className="w-5 h-5 md:w-6 md:h-6 text-brand-blue" data-id="element-212" />
          <span className="text-[11px] md:text-sm font-bold text-white leading-tight" data-id="element-213">
            {label}
          </span>
        </div>)}
    </div>;
}